<template>
    <div id="srt_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span v-if="isEditPage" class="page-title" id="srtHeader">Update SRT</span>
                    <span v-else class="page-title" id="srtHeader">Add SRT</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackSrtList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content srt-create">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="SrtForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="operation_code"> Operation Code:</label>
                                        <input type="text" class="form-control" v-model="operation_code" id="operation_code" placeholder="Enter Operation Code" name="operation_code">
                                        <div class="field-error">{{operation_code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="falcon_code"> Falcon Code:</label>
                                        <input type="text" class="form-control" v-model="falcon_code" id="falcon_code" placeholder="Enter Falcon Code" name="falcon_code">
                                        <div class="field-error">{{falcon_code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="hours"> Hours:</label>
                                        <input type="number" class="form-control" v-model="hours" id="hours" placeholder="Enter Hour" name="hours">
                                        <div class="field-error">{{hours_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="work_description"> Work Description:</label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="work_description"
                                            id="work_description"
                                            placeholder="Enter Work Description"
                                            name="work_description"
                                        ></textarea>
                                        <div class="field-error">{{work_description_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="additional_information"> Additional Information:</label>
                                        <textarea
                                            type="text"
                                            class="form-control"
                                            v-model="additional_information"
                                            id="additional_information"
                                            placeholder="Enter Additional Information"
                                            name="additional_information"
                                        ></textarea>
                                        <div class="field-error">{{additional_information_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="from-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button v-if="isEditPage" type="submit" id="createSrtBtn" class="btn btn-primary" v-on:click.prevent="CreateSrt">
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button v-else type="submit" id="createSrtBtn" class="btn btn-primary" v-on:click.prevent="CreateSrt">
                                        <i class="fp-reload"> </i>  Create
                                    </button>

                                    <button type="submit" id="cancelSrtBtn" class="btn btn-tertiary" v-on:click.prevent="BackSrtList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { commonMixins } from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content",LoadingContent);

export default{
    name: "SrtCreate",
    components: {
        appFooter: () => import('@/components/Footer')
    },
    metaInfo(){
        return {
            title: (this.$route.params.id > 0) ? "Update SRT | " + process.env.COPYRIGHT_NAME : "Create SRT | " + process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        operation_code: "",
        falcon_code: "",
        hours: "",
        work_description: "",
        additional_information: "",
        velocity_env:process.env.NODE_ENV,
        isEditPage: false,
        operation_code_error_msg: "",
        falcon_code_error_msg: "",
        hours_error_msg: "",
        work_description_error_msg: "",
        additional_information_error_msg: "",
        srtId: null,
        loading:false,

    }),
    watch: {
        permissions: function (permissions){
            if (permissions.length > 0){
                for (const element of permissions){
                    if(element.name == 'ev_add_srt'){
                        this.cantAccessPage = true;
                    }
                }
            }
        }
    },

    mounted: function (){
        this.getPermissions();
        if(this.$route.params.id > 0){
            this.isEditPage = true;
            this.srtId = this.$route.params.id;
            this.loadSrtData();
            // todo call loadSrt function
        }
    },
    methods: {
        BackSrtList(){
            this.$router.push("/srt/list");
        },
        CreateSrt(){
            var self = this;
            let validity = this.validateSrtFields();
            if(validity){
                self.loading = true;
                this.disableButtons();
                var fields = this.prepareSrtFields();
                $.ajax({
                    url: process.env.ROOT_API + "/srt/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function(data){
                        self.loading = false;
                        self.enableButtons();
                        if(data.status == "success"){
                            self.$router.push("/srt/list");
                        }else{
                            $("#errorMsg").html(data.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.enableButtons();
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                })
            }
        },
        validateSrtFields(){
            this.operation_code_error_msg = "";
            this.falcon_code_error_msg = "";
            this.hours_error_msg = "";
            this.work_description_error_msg = "";
            this.additional_information_error_msg = "";
            let validity = true;

            if(this.operation_code == ""){
                this.operation_code_error_msg = "Operation Code is requried!";
                validity =  false;
            }

            if(this.falcon_code == ""){
                this.falcon_code_error_msg = "Falcon Code is requried!";
                validity =  false;
            }

            if(this.hours == ""){
                this.hours_error_msg = "Hour is requried!";
                validity =  false;
            }

            return validity;
        },
        prepareSrtFields(){
            var fields = $('#SrtForm').serializeArray();
            fields.push({name: "srt_id", value: this.srtId});

            return fields;
        },
        disableButtons(){
            if (this.isEditPage){
                $("#createSrtBtn").val("Updating ...");
                $("#createSrtBtn").prop("disabled", true);
                $("#cancelSrtBtn").prop("disabled",true);
            } else {
                $("#createSrtBtn").val("Saving ...");
                $("#createSrtBtn").prop("disabled", true);
                $("#cancelSrtBtn").prop("disabled",true);
            }
        },
        enableButtons(){
            if (this.isEditPage){
                $("#createSrtBtn").val("Update");
                $("#createSrtBtn").prop("disabled", false);
                $("#cancelSrtBtn").prop("disabled",false);
            } else {
                $("#createSrtBtn").val("Create");
                $("#createSrtBtn").prop("disabled", false);
                $("#cancelSrtBtn").prop("disabled",false);
            }
        },
        loadSrtData(){
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/srt/" + self.srtId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.work_description = data.content.work_description;
                        self.additional_information = data.content.additional_information;
                        self.operation_code = data.content.operation_code;
                        self.falcon_code = data.content.falcon_code;
                        self.hours = data.content.hours;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/SrtCreate.vue